import React from 'react';
import background from '../../assets/jaxa.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';


class InfoJaxa extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="NEAR SPACE"
        subtag="Tokyo, Japan"
        description="JAXA"
        paragraph="The Japan Aerospace Exploration Agency is the Japanese national aerospace and space agency. "
        background={background}
     />
  
  );
 }
}   

export default InfoJaxa;